// Chakra imports
import { Box, Flex, Icon, Text, useColorModeValue } from '@chakra-ui/react';
// Custom components
import Card from 'components/card/Card';
import LineChart from 'components/charts/LineChart';
import { MdOutlineCalendarToday } from 'react-icons/md';
// Assets
import { RiArrowDownSFill, RiArrowUpSFill } from 'react-icons/ri';
import { lineChartOptions } from 'variables/charts';
import { formatEuros, variation } from 'views/admin/default/dashboardData';

// Chiffre d'affaires des forfaits par mois de début : 12 derniers mois et année précédente
export default function RevenueByMonth(props: {
	labels: string[];
	current: number[];
	previous: number[];
	total: number;
	previousTotal: number;
	[x: string]: any;
}) {
	const { labels, current, previous, total, previousTotal, ...rest } = props;

	// Chakra Color Mode
	const textColor = useColorModeValue('secondaryGray.900', 'white');
	const textColorSecondary = useColorModeValue('secondaryGray.600', 'white');
	const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');

	const change = variation(total, previousTotal);
	const chartData = [
		{ name: '12 derniers mois', data: current },
		{ name: 'Année précédente', data: previous }
	];
	const chartOptions = {
		...lineChartOptions,
		xaxis: { ...lineChartOptions.xaxis, type: 'category', categories: labels },
		tooltip: { ...lineChartOptions.tooltip, y: { formatter: formatEuros } },
		legend: { show: true, position: 'top', horizontalAlign: 'right', labels: { colors: '#A3AED0' } }
	};

	return (
		<Card justifyContent='center' alignItems='center' flexDirection='column' w='100%' mb='0px' {...rest}>
			<Flex align='center' justify='space-between' w='100%' pe='20px' pt='5px'>
				<Flex
					align='center'
					bg={boxBg}
					fontSize='sm'
					fontWeight='500'
					color={textColorSecondary}
					borderRadius='7px'
					px='16px'
					h='40px'>
					<Icon as={MdOutlineCalendarToday} color={textColorSecondary} me='4px' />
					12 derniers mois
				</Flex>
			</Flex>
			<Flex w='100%' flexDirection={{ base: 'column', lg: 'row' }}>
				<Flex flexDirection='column' me='20px' mt='28px'>
					<Text color={textColor} fontSize='34px' textAlign='start' fontWeight='700' lineHeight='100%'>
						{formatEuros(total)}
					</Text>
					<Flex align='center' mb='20px'>
						<Text color='secondaryGray.600' fontSize='sm' fontWeight='500' mt='4px' me='12px'>
							CA des forfaits
						</Text>
						{change !== null && (
							<Flex align='center'>
								<Icon
									as={change >= 0 ? RiArrowUpSFill : RiArrowDownSFill}
									color={change >= 0 ? 'green.500' : 'red.500'}
									me='2px'
									mt='2px'
								/>
								<Text color={change >= 0 ? 'green.500' : 'red.500'} fontSize='sm' fontWeight='700'>
									{change > 0 ? '+' : ''}
									{change} %
								</Text>
							</Flex>
						)}
					</Flex>
					<Text color='secondaryGray.600' fontSize='xs' fontWeight='500'>
						Année précédente : {formatEuros(previousTotal)}
					</Text>
				</Flex>
				<Box minH='260px' minW='75%' mt='auto'>
					<LineChart chartData={chartData} chartOptions={chartOptions} />
				</Box>
			</Flex>
		</Card>
	);
}
